<template>
  <div v-loading="isLoading">
    <el-form inline :model="form" ref="form">
      <el-form-item prop="name">
        <el-input v-model="form.name" style="width: 300px;" placeholder="店名/グループ名/ライセンスコード"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="form.licenseItems"
          icon="search"
          placeholder="契約項目"
          multiple>
          <el-option value="hasCrmLicense" label="crm" key="crm"></el-option>
          <el-option value="hasSalesReportLicense" label="sr" key="sr"></el-option>
          <el-option value="hasReserveLicense" label="reserve" key="reserve"></el-option>
          <el-option value="hasSalesCsvExportLicense" label="sr_csv_export" key="sr_csv_export"></el-option>
          <el-option value="hasCustomerCsvImportLicense" label="crm_csv_import" key="crm_csv_import"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="clearForm">クリア</el-button>
      </el-form-item>
      <el-button icon="el-icon-refresh" @click="fetchData"></el-button>
    </el-form>
    <el-table
      stripe
      border
      :data="filteredShops">
      <el-table-column
        label="店舗名"
        sortable
        prop="name" />
      <el-table-column
        label="ライセンスコード"
        prop="licenseCode" />
      <el-table-column
        label="グループ"
        sortable
        prop="groupName" />
      <el-table-column
        label="契約状況">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.hasCrmLicense">crm</el-tag>
          <el-tag type="primary" v-if="scope.row.hasSalesReportLicense">sr</el-tag>
          <el-tag type="warning" v-if="scope.row.hasReserveLicense">reserve</el-tag>
          <el-tag type="success" v-if="scope.row.hasSalesCsvExportLicense">sr_csv_export</el-tag>
          <el-tag type="primary" v-if="scope.row.hasCustomerCsvImportLicense">crm_csv_import</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        width="240"
        align="center"
        label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click="changeShop(scope.row)">切り替え</el-button>
          <el-button type="warning" @click="changeLoginAsShop(scope.row)">ログイン</el-button>
        </template>
      </el-table-column>
    </el-table>
    {{ filteredShops.length }}件 (総計 {{ total }}件)
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import moment from 'moment'

export default {
  name: 'ShopSelectShopTable',
  data () {
    return {
      shops: [],
      total: 0,
      isLoading: false,
      sortParam: null,
      form: {
        name: '',
        licenseItems: [],
      },
    }
  },
  computed: {
    filteredShops () {
      let shops = this.shops.filter(x => x.isAvailable !== false)
      if (this.form.name !== '' && this.form.name !== null) {
        shops = shops.filter(x => (x.name.includes(this.form.name) ||
                                   (x.groupName && x.groupName.includes(this.form.name)) ||
                                   x.licenseCode.includes(this.form.name)))
      }
      if (this.form.licenseItems) {
        this.form.licenseItems.forEach(val => {
          shops = shops.filter(x => x[val])
        })
      }
      const now = moment()
      return shops.map(obj => {
        obj.licenseItems.forEach(x => {
          switch (x.name) {
            case 'sales_report':
              obj.hasSalesReportLicense = true
              if (now.isAfter(x.expiredAt)) {
                obj.isSalesReportLicenseExpired = true
              }
              if (now.isBefore(x.startAt)) {
                obj.isSalesReportLicenseBefore = true
              }
              break
            case 'customer':
              obj.hasCrmLicense = true
              if (now.isAfter(x.expiredAt)) {
                obj.isCrmLicenseExpired = true
              }
              if (now.isBefore(x.startAt)) {
                obj.isCrmLicenseBefore = true
              }
              break
            case 'reserve':
              obj.hasReserveLicense = true
              if (now.isAfter(x.expiredAt)) {
                obj.isReserveLicenseExpired = true
              }
              if (now.isBefore(x.startAt)) {
                obj.isReserveLicenseBefore = true
              }
              break
            case 'sales_csv_export':
              obj.hasSalesCsvExportLicense = true
              if (now.isAfter(x.expiredAt)) {
                obj.isSalesCsvExportLicenseExpired = true
              }
              if (now.isBefore(x.startAt)) {
                obj.isSalesCsvExportLicenseBefore = true
              }
              break
            case 'customer_csv_import':
              obj.hasCustomerCsvImportLicense = true
              if (now.isAfter(x.expiredAt)) {
                obj.isCustomerCsvImportLicenseExpired = true
              }
              if (now.isBefore(x.startAt)) {
                obj.isCustomerCsvImportLicenseBefore = true
              }
              break
            case 'mds':
              obj.hasMdsLicense = true
              if (now.isAfter(x.expiredAt)) {
                obj.isMdsLicenseExpired = true
              }
              if (now.isBefore(x.startAt)) {
                obj.isMdsLicenseBefore = true
              }
              break
          }
        })
        return obj
      })
    },
  },
  methods: {
    ...mapActions({
      setAsShop: 'account/setAsShop',
      changeLogin: 'account/changeLogin',
    }),
    getParams () {
      let ret = {}
      if (this.sortParam) {
        ret['ordering'] = this.sortParam
      }
      return ret
    },
    fetchData () {
      this.isLoading = true
      this.$request.shops.all(shops => {
        this.total = shops.length
        this.shops = shops
      }).finally(() => {
        this.isLoading = false
      })
    },
    changeShop (row) {
      this.setAsShop(row.pk).then(res => {
        this.$router.push({name: 'Home'})
      })
    },
    changeLoginAsShop (row) {
      this.isLoading = true
      this.$request.admin.auth.changeLoginAsShop(row.pk).then(res => {
        return this.changeLogin(res.body.token)
      }).then(() => {
        this.$router.push({name: 'Home'})
      }).finally(() => {
        this.isLoading = false
      })
    },
    clearForm () {
      this.$refs.form.resetFields()
    },
  },
  mounted () {
    this.fetchData()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ShopSelect/ShopTable.vue